export default __webpack_public_path__ + "./fonts/person.f30d25cd.svg";